<button
  #lumiPopoverBtn
  #popperDir="pxTooltip"
  [pxTooltipDisabled]="lumiPanelOpen"
  pxTooltip="Lumi"
  pxTooltipPlacement="right"
  class="lumi-container"
  (click)="popperDir.hide(); onLumiLauncherClick()"
  aria-label="Lumi"
>
  <img src="assets/img/Lumi.svg">
</button>

<div
  #lumiPopover
  id="lumi-popover"
  class="lumi"
  [ngClass]="{'addin': addin, 'expanded': isExpandable && expanded, 'lumi-panel-open': lumiPanelOpen}"
>
  <div class="lumi-body">
    <div class="lumi-header" [ngClass]="mode">
      <img class="lumi-logo" src="assets/img/Lumi-full.svg"/>
      <div class="lumi-expand-dismiss">
        <div class="lumi-expand animate__animated animate__fadeIn" *ngIf="[LumiMode.POLARIX_HELP, LumiMode.PROJECT_HELP].includes(mode)" (click)="toggleExpanded()">
          <app-centrui-icon [ngClass]="'lumi-expand-icon'" [file]="expanded ? 'new/arrow-shrink.svg' : 'new/arrow-expand.svg'" style="width: 1rem; height: 1rem; opacity: 0.6;" [pxTooltip]="expanded ? 'Contract' : 'Expand'" pxTooltipPlacement="top"></app-centrui-icon>
        </div>
        <button type="button" class="lumi-dismiss" (click)="closeLumiPanel()">
          <app-centrui-icon [file]="'ic-close.svg'" style="width: 1rem; height: 1rem; opacity: 0.6;"></app-centrui-icon>
        </button>
      </div>
    </div>
    <div #lumiContent class="lumi-content" [ngClass]="mode">
      <ng-container [ngSwitch]="mode">
        <div class="lumi-mode-panel" [ngClass]="LumiMode.HOME" *ngSwitchCase="LumiMode.HOME">
          <div class="lumi-title" [@fadeInUp]="{ value: '', params: { delay: 0 } }">Hello {{ userFirstName }} 👋</div>
          <div class="lumi-subtitle" [@fadeInUp]="{ value: '', params: { delay: 80 } }">How can I help?</div>
          <div class="lumi-buttons">
            <button class="lumi-button" [@fadeInUp]="{ value: '', params: { delay: 280 } }" (click)="setMode(LumiMode.POLARIX_HELP, undefined, LumiSkill.PLATFORM_QA)">
              <span>Polarix help</span>
              <p>I can help you with general questions about Polarix and how to use it's features.</p>
            </button>
            <button class="lumi-button" *ngIf="isOnProjectPage && project && platformService.isFeatureEnabled(Feature.LUMI_CHAT)" [@fadeInUp]="{ value: '', params: { delay: 370 } }" (click)="setMode(LumiMode.PROJECT_HELP, undefined, LumiSkill.PROJECT_QA)">
              <span>Project help</span>
              <p>I can assist with the project <strong>{{project.title}}</strong>. <br> Click here to ask me questions.</p>
            </button>
            <button class="lumi-button" [@fadeInUp]="{ value: '', params: { delay: 460 } }" (click)="setMode(LumiMode.HELP_REQUEST)">
              <span>Submit help request</span>
              <p>If I can't help then feel free to send the support team a message</p>
            </button>
          </div>
        </div>

        <div class="lumi-mode-panel" [ngClass]="LumiMode.HELP_REQUEST" @panelEnter *ngSwitchCase="LumiMode.HELP_REQUEST">
          <div class="return-title">
            <div class="return-icon">
              <app-centrui-icon (click)="helpRequestBack()" [file]="'ic-chevron-left.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
            </div>
            <span>{{titleAction}}</span>
          </div>
          <div class="help-form-submitted" *ngIf="helpFormTicketNumber">
            <div class="help-form-submitted-title"> 🙏 <br> Thank you, your help request has been submitted and one of the team will come back to you as soon as possible.</div>
            <div class="help-form-submitted-subtitle">Support is managed by Freshdesk and your ticket number is #{{helpFormTicketNumber}}</div>
          </div>
          <app-centrui-help-form theme="lumi" [runShow]="true" [helpFormVisible]="true" [hideHeader]="true" [hideLaunchButton]="true" [smallButtons]="true" (dismissed)="dismissedHelpForm($event)"></app-centrui-help-form>
        </div>

        <div class="lumi-mode-panel" [ngClass]="LumiMode.PROJECT_HELP" @panelEnter *ngSwitchCase="LumiMode.PROJECT_HELP">
          <app-lumi-chat [mode]="mode" [project]="project" [title]="titleAction" [threadId]="activeThreadId" [skill]="activeSkill" (back)="setMode($event === 'home' ? LumiMode.HOME : LumiMode.HISTORY)" (threadResolved)="activeThreadId = $event"></app-lumi-chat>
        </div>

        <div class="lumi-mode-panel" [ngClass]="LumiMode.POLARIX_HELP" @panelEnter *ngSwitchCase="LumiMode.POLARIX_HELP">
          <app-lumi-chat [mode]="mode" [project]="project" [title]="titleAction" [threadId]="activeThreadId" [skill]="activeSkill" (back)="setMode($event === 'home' ? LumiMode.HOME : LumiMode.HISTORY)" (threadResolved)="activeThreadId = $event"></app-lumi-chat>
        </div>

        <div class="lumi-mode-panel" [ngClass]="LumiMode.HISTORY" *ngSwitchCase="LumiMode.HISTORY">
          <div class="return-title" [@fadeInUp]="{ value: '', params: { delay: 0 } }">
            <div class="return-icon">
              <app-centrui-icon (click)="setMode(LumiMode.HOME)" [file]="'ic-chevron-left.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
            </div>
            <span>{{titleAction}}</span>
          </div>
          <div class="history-list" #historyList (scroll)="onHistoryScroll()">
            <div class="lumi-list-loading" *ngIf="loadingConversations">
              <app-lumi-loading size="3rem"></app-lumi-loading>
            </div>
            <ng-container *ngIf="!loadingConversations">
            <div class="history-item support" [@fadeInUp]="{ value: '', params: { delay: 0 } }" (click)="setMode(LumiMode.SUPPORT_MESSAGES)">
              <div class="history-item-image">
                <app-centrui-icon [ngClass]="'history-item-image-icon'" [file]="'ic-nav-help.svg'"></app-centrui-icon>
              </div>
              <div class="history-item-content">
                <span class="history-item-title">Support messages</span>
              </div>
              <div class="history-item-chevron">
                <app-centrui-icon [file]="'ic-chevron-right.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
              </div>
            </div>

            <div class="no-conversations-message" *ngIf="conversations.length === 0" [@fadeInUp]="{ value: '', params: { delay: 100 } }">
              <p>No conversations found.<br> When you start a conversation, you'll see it here.</p>
            </div>

            <div class="history-item" (click)="openConversationFromHistory(conversation)" *ngFor="let conversation of conversations; let i = index; trackBy: trackByConversation" [@fadeInUp]="{ value: '', params: { delay: conversationFadeInDelay(i) } }">
              <div class="history-item-image" *ngIf="isProjectConversation(conversation); else polarixConversationTemplate" [ngClass]="{'project-image': conversation.project && conversation.project.logo}">
                <ng-container *ngIf="conversation.project && conversation.project.logo; else ProjectInitials">
                  <img [src]="conversation.project.logo" [alt]="conversation.project.title">
                </ng-container>
                <ng-template #ProjectInitials>
                  <div class="project-initials">
                    {{ conversation.title?.charAt(0) || '?' }}
                  </div>
                </ng-template>
              </div>
              <ng-template #polarixConversationTemplate>
                <div class="history-item-image">
                  <img src="assets/icons/polarix-icon.svg">
                </div>
              </ng-template>
              <div class="history-item-content">
                <span class="history-item-title">{{ conversation.project ? conversation.project.title : conversation.title }}</span>
                <span class="history-item-subtitle">{{ conversation.updated_at | date:'d MMMM y | HH:mm' }}</span>
              </div>
              <div class="history-item-chevron">
                <app-centrui-icon [file]="'ic-chevron-right.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
              </div>
            </div>
            <div class="history-load-more" *ngIf="loadingMoreConversations">
              <app-centrui-spinner [sizeInRem]="2"></app-centrui-spinner>
            </div>
            </ng-container>
          </div>
        </div>

        <div class="lumi-mode-panel" [ngClass]="LumiMode.INFO" @panelEnter *ngSwitchCase="LumiMode.INFO">
          <div class="return-title">
            <div class="return-icon">
              <app-centrui-icon (click)="setMode(LumiMode.HOME)" [file]="'ic-chevron-left.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
            </div>
            <span>{{titleAction}}</span>
          </div>
          <p class="ai-assistant">Your AI Assistant in Polarix</p>
          <div class="lumi-info-content">
            <p>Lumi is here to help you get the most out of Polarix. Whether you need guidance on how to use the platform, support with a project, or quick insights to strengthen your hypotheses, Lumi is designed to make your work easier. You can even use Lumi for content generation tasks tailored to your project.</p>
            <br>
            <p>Whenever you see the Lumi icon, assistance is just a click away. And because your experience matters, you can share feedback at any time with a quick thumbs up or down &#x2014; or add written feedback if you'd like. This helps the 9LABS team continually improve Lumi for you.</p>
            <br>
            <p>Your privacy and security come first. Lumi runs on localized large language models and technologies, ensuring your data stays private and protected at all times.</p>
            <br>
            <p class="knowledge-base">For more information please visit the knowledge base</p>
            <div class="about-lumi-button-wrapper">
              <button class="about-lumi-button"><img src="assets/img/Lumi.svg"> About Lumi</button>
            </div>
          </div>
        </div>
        <div class="lumi-mode-panel" [ngClass]="LumiMode.SUPPORT_MESSAGES" @panelEnter *ngSwitchCase="LumiMode.SUPPORT_MESSAGES">
          <div class="return-title">
            <div class="return-icon">
              <app-centrui-icon (click)="setMode(LumiMode.HISTORY)" [file]="'ic-chevron-left.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
            </div>
            <span>{{titleAction}}</span>
          </div>
          <div class="support-message-list">
            <div class="lumi-list-loading" *ngIf="loadingFreshDeskTickets">
              <app-lumi-loading size="3rem"></app-lumi-loading>
            </div>
            <ng-container *ngIf="!loadingFreshDeskTickets">
              <div *ngIf="freshDeskTickets.length === 0" class="no-tickets-message" [@fadeInUp]="{ value: '', params: { delay: 0 } }">
                <p>No support messages found.<br> When you submit a help request, you'll see it here.</p>
              </div>
              <div class="support-message-item" *ngFor="let ticket of freshDeskTickets; let i = index" [@fadeInUp]="{ value: '', params: { delay: 190 * i } }" (click)="openFreshDeskTicket(ticket.id)">
                <div class="support-message-item-image" [ngClass]="getTicketStatusClass(ticket.status)">
                  <app-centrui-icon [ngClass]="'support-message-item-icon'" [file]="'ic-nav-help.svg'"></app-centrui-icon>
                </div>
                <div class="support-message-item-content">
                  <span class="support-message-item-title">Support request #{{ticket.id}}</span>
                  <span class="support-message-item-subtitle">{{ticket.updated_at | date:'dd MMMM yyyy | HH:mm'}}</span>
                </div>
                <div class="support-message-item-chevron">
                  <app-centrui-icon [file]="'new/link-04.svg'"></app-centrui-icon>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="lumi-footer">
      <div class="lumi-footer-item" [class.active]="mode === LumiMode.HOME" (click)="setMode(LumiMode.HOME)">
        <app-centrui-icon [file]="'new/home-07.svg'"></app-centrui-icon>
        <span>Home</span>
      </div>
      <div class="lumi-footer-item history" [class.active]="mode === LumiMode.HISTORY" (click)="setMode(LumiMode.HISTORY)">
        <app-centrui-icon [file]="'new/history.svg'"></app-centrui-icon>
        <span>History</span>
      </div>
      <div class="lumi-footer-item" [class.active]="mode === LumiMode.INFO" (click)="setMode(LumiMode.INFO)">
        <app-centrui-icon [file]="'new/information-circle.svg'"></app-centrui-icon>
        <span>Info</span>
      </div>
    </div>
  </div>
</div>
